import API from "../index";

export const getCms = async (type) => {
    return API.get(`/cms/${type}`);
};
